<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import Modal from "./Modal.vue";
import { Button } from "@starline-security/component-library";
const store = useStore();
const show = computed(() => store.state["successFeedback"].show);
const title = computed(() => store.state["successFeedback"].title);
const description = computed(() => store.state["successFeedback"].description);
const handleClose = () => {
  store.commit("successFeedback/close");
};
</script>

<template>
  <Modal v-if="show" :handle-close="handleClose">
    <div class="tw-card-modal tw:mx-4 tw:my-8 tw:max-w-md">
      <div class="tw-card-body-modal">
        <div class="tw:flex tw:justify-center">
          <div
            class="
              tw:w-10
              tw:h-10
              tw:bg-green-200
              tw:flex
              tw:justify-center
              tw:items-center
            "
          >
            <svg-icon
              name="solid/check"
              class="tw:text-green-600 tw:h-5 tw:w-5"
            ></svg-icon>
          </div>
        </div>
        <h4 class="tw:text-center tw:mt-4 tw:text-lg tw:font-medium">
          SUCCESS
        </h4>
        <p class="tw:mt-1 tw:text-center tw:text-gray-500">
          {{ description }}
        </p>
        <div>
          <Button
            variant="secondary"
            size="md"
            class="
              tw:w-full tw:mt-4 tw:h-full tw:whitespace-nowrap tw:px-10 tw:py-2
            "
            @click="handleClose()"
          >
            CLOSE
          </Button>
        </div>
      </div>
    </div>
  </Modal>
</template>
